import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Edit2Icon } from '../../../assets/images/edit-2-icon.svg';

const PlanogramHeader = ({ title, columns, rows, onRenameClick, rightContent, children, isReadOnlyMode = false, systemId, externalSystemId }) => {
    const { t } = useTranslation();
    const getFormattedTitle = () => {
        if (columns && rows) {
            return `${rows}x${columns} - ${title}`;
        }
        return title;
    };

    return (
        <div className='planogram-header'>
            <div className='toolbar'>
                <div className='flex items-center justify-content-between w-full'>
                    <div className='flex items-center gap-3'>
                        <h2 className="font-inter-title">
                            {getFormattedTitle()}
                        </h2>
                        {(systemId || externalSystemId) && (
                            <div className="flex align-items-center gap-3 font-inter-title">
                                {systemId && (
                                    <span>{t('planogramsPage.systemId')}:  {systemId} </span>
                                )}
                                {externalSystemId && (
                                    <span>{t('planogram.create.planogramId')}:  {externalSystemId}</span>
                                )}
                            </div>
                        )}
                        <h2 className="font-inter-title">
                            {onRenameClick && (
                                <Edit2Icon
                                    className={isReadOnlyMode ? '' : 'cursor-pointer'}
                                    onClick={isReadOnlyMode ? undefined : onRenameClick}
                                    style={isReadOnlyMode ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}
                                />
                            )}
                        </h2>
                    </div>
                    <div className='flex gap-3'>
                        {rightContent}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlanogramHeader;
